<template>
  <b-modal id="base-popup" :title="title" @ok="test" @hidden="$bvModal.hide('base=popup')">
    {{ content }}
  </b-modal>
</template>

<script>
export default {
  name: "BasePopup",
  props: {
    title: String,
    content: String,
    okHandler: Function,
  },
  methods: {
    test() {
      this.okHandler();
    }
  },
}
</script>